import Cookies from 'quasar/src/plugins/Cookies.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import Platform from 'quasar/src/plugins/Platform.js';

const COOKIE_OPTIONS = {
  path: '/',
  expires: 365 * 5,
  sameSite: 'Lax',
  secure: true,
  domain: process.env.DOMAIN,
}

export const MyStorage = {
  get: Platform.is.capacitor ? LocalStorage.getItem : Cookies.get,
  remove: key => Platform.is.capacitor ? LocalStorage.remove(key) : Cookies.remove(key, COOKIE_OPTIONS),
  has: key => (Platform.is.capacitor ? LocalStorage.has(key) : Cookies.has(key)) && !!MyStorage.get(key),
  set: (key, value) => Platform.is.capacitor ? LocalStorage.set(key, value) : Cookies.set(key, value, COOKIE_OPTIONS),
}
